<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.ahcoUserName" style="width: 120px;" size="mini" placeholder="姓名"
                        clearable></el-input>
                    <el-input v-model="formDatas.ahcoUserDepartment" style="width: 120px;" size="mini" placeholder="部门"
                        clearable></el-input>
                    <el-select size="mini" v-model="formDatas.ahcoStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px">
                        <el-option label="未处理" :value="1" key="1"></el-option>
                        <el-option label="按要求退房" :value="2" key="2"></el-option>
                        <el-option label="未按要求退房" :value="3" key="3"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                    <!-- <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增退房申请</el-button> -->

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="ahcoId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑退房申请' : '新增退房申请'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">

                            <el-form-item label="是否过期" prop="hasExpired">
                                <el-select v-model="form.hasExpired" clearable placeholder="请选择" style="width: 130px">
                                    <el-option label="是" value="是" key="1"></el-option>
                                    <el-option label="否" value="否" key="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <el-dialog title="状态" :visible.sync="dialogStatus" width="70%" top="8vh">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formCheck" :model="formCheck" label-position="top" label-width="150px"
                            @submit.native.prevent>
                            <el-form-item label="是否同意" prop="ahcoStatus">
                                <el-radio-group v-model="formCheck.ahcoStatus">
                                    <el-radio label="2">按要求退房</el-radio>
                                    <el-radio label="3">未按要求退房</el-radio>
                                </el-radio-group>
                            </el-form-item>
                           
                            <el-form-item label="审核备注" prop="checkDes">
                                <el-input v-model="formCheck.checkDes" style="width: 100%;" placeholder="请输入"
                                    type="textarea"></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="closeStatus">取 消</el-button>
                            <el-button type="primary" @click="sureStatus">确 定</el-button>
                        </span>
                    </div>
                </div>
            </el-dialog>
            <!-- 批量导入 -->
            <el-dialog title="批量导入" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
                style="margin-left: 200px;">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size=" medium" type="danger">点击上传</el-button>

                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('https://trainapp.aojuai.com/assets/excel/fireequipment.xlsx', '退房申请模板')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div style="margin: 10px;font-size: 18px;" v-if="bulkData.length != 0">
                    <span style="color: #0080FF;">一共{{ importData.numAll }}条;</span>
                    <span style="color: #0E9A00;margin-left: 5px;">成功{{ importData.numSuccess }}条;</span>
                    <span style="color: red;margin-left: 5px;">失败{{ importData.numFail }}条</span>
                    <span style="color: #E6A23C;margin-left: 5px;">信息不完整{{ importData.numUnWhole }}条</span>
                </div>
                <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                    <!-- <el-button @click="bulkImportClose">取 消</el-button> -->
                    <el-button type="success" @click="bulkImportClick">确定导入</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjHostelBaseList, updateAjHostelCheckOutCheck, uploadImportAjAssetsFireEquipment, getAjHostelCheckOutList, addAjAssetsFireEquipment, updateAjAssetsFireEquipment, deleteAjAssetsFireEquipment, uploadAjAssetsFireEquipment } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            formCheck: {},
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            statusAll: [
            ],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'ahcoId',
            dialog: false,
            edit: false,
            form: {
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columnsImport: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "aafeNums",
                    key: "aafeNums",
                    title: "灭火器编号",
                    align: "center",
                },
                {
                    field: "equipmentName",
                    key: "equipmentName",
                    title: "设备名称",
                    align: "center",
                },
                {
                    field: "storageLocation",
                    key: "storageLocation",
                    title: "存放位置",
                    align: "center",
                },
                {
                    field: "purchaseDate",
                    key: "purchaseDate",
                    title: "购买日期",
                    align: "center",
                },
                {
                    field: "netWeight",
                    key: "netWeight",
                    title: "净含量",
                    align: "center",
                    edit: true,
                },
                {
                    field: "modelC",
                    key: "modelC",
                    title: "3C规格型号",
                    align: "center",
                    edit: true,
                },
                {
                    field: "cccCertificateNumber",
                    key: "cccCertificateNumber",
                    title: "ccc证书编号",
                    align: "center",
                },
                {
                    field: "manufacturer",
                    key: "manufacturer",
                    title: "制造厂家",
                    align: "center",
                },
                {
                    field: "hasLabel",
                    key: "hasLabel",
                    title: "是否有标签",
                    align: "center",
                },
                {
                    field: "hasExpired",
                    key: "hasExpired",
                    title: "是否过期",
                    align: "center",
                },
                {
                    field: "personInCharge",
                    key: "personInCharge",
                    title: "负责人",
                    align: "center",
                },
                {
                    field: "expectedExpiryDate",
                    key: "expectedExpiryDate",
                    title: "预计到期时间",
                    align: "center",
                },
                {
                    field: "remarks",
                    key: "remarks",
                    title: "备注",
                    align: "center",
                },
            ],

            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",

                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "ahcoUserName",
                    key: "ahcoUserName",
                    title: "申请人",
                    align: "center",
                    edit:false,
                    width: 140,
                },
                {
                    field: "ahcoUserDepartment",
                    key: "ahcoUserDepartment",
                    title: "申请人部门",
                    align: "center",
                    edit:false,
                    width: 100,
                },
                {
                    field: "ahcoDateCheckOut",
                    key: "ahcoDateCheckOut",
                    title: "实际退房时间",
                    edit:false,
                    align: "center",
                    width: 150,
                },
              
                {
                    field: "ahcoTwo",
                    key: "ahcoTwo",
                    title: "用过床单被罩枕套",
                    align: "center",
                    width: 120,
                    edit:false,
                },
                {
                    field: "ahcoTwoSign",
                    key: "ahcoTwoSign",
                    title: "用过床单被罩枕套拍照",
                    align: "center",
                    edit:false,
                    width: 350,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:80%;">
                                    {
                                        row.ahcoTwoSign ? (JSON.parse(row.ahcoTwoSign || [])).map((item) => {
                                            return <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="fill" style="width: 80px;height: 50px;"
                                                previewSrcList={JSON.parse(row.ahcoTwoSign || [])}></el-image>
                                        }) : <span></span>
                                    }

                                </div>
                            </span>

                        );
                    },
                },
                 {
                    field: "ahcoThree",
                    key: "ahcoThree",
                    title: "钥匙归还",
                    align: "center",
                    edit:false,
                    width: 100,
                },
                {
                    field: "ahcoThreeSign",
                    key: "ahcoThreeSign",
                    title: "钥匙归还拍照",
                    align: "center",
                    width: 250,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:80%;">
                                    {
                                        row.ahcoThreeSign ? (JSON.parse(row.ahcoThreeSign || [])).map((item) => {
                                            return <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="fill" style="width: 80px;height: 50px;"
                                                previewSrcList={JSON.parse(row.ahcoThreeSign || [])}></el-image>
                                        }) : <span></span>
                                    }

                                </div>
                            </span>

                        );
                    },
                },
                  {
                    field: "ahcoFour",
                    key: "ahcoFour",
                    title: "宿舍内原有生活备用品是否需要补充",
                    align: "center",
                    edit:false,
                    width: 250,
                },
                  {
                    field: "ahcoFourDes",
                    key: "ahcoFourDes",
                    title: "补充描述",
                    align: "center",
                    edit:false,
                    width: 200,
                },
                 {
                    field: "ahcoFive",
                    key: "ahcoFive",
                    title: "个人物品是否都清理干净，房间内无垃圾？",
                    align: "center",
                    edit:false,
                    width: 280,
                },
                {
                    field: "ahcoFiveSign",
                    key: "ahcoFiveSign",
                    title: "房间拍照",
                    align: "center",
                    width: 350,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:80%;">
                                    {
                                        row.ahcoFiveSign ? (JSON.parse(row.ahcoFiveSign || [])).map((item) => {
                                            return <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="fill" style="width: 80px;height: 50px;"
                                                previewSrcList={JSON.parse(row.ahcoFiveSign || [])}></el-image>
                                        }) : <span></span>
                                    }

                                </div>
                            </span>

                        );
                    },
                },
                   {
                    field: "ahcoSix",
                    key: "ahcoSix",
                    title: "门锁/空调/窗户是否已检查关好",
                    align: "center",
                    edit:false,
                    width: 250,
                },
                {
                    field: "ahcoSixSign",
                    key: "ahcoSixSign",
                    title: "门锁/空调/窗户 拍照",
                    align: "center",
                    width: 350,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:80%;">
                                    {
                                        row.ahcoSixSign ? (JSON.parse(row.ahcoSixSign || [])).map((item) => {
                                            return <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="fill" style="width: 80px;height: 50px;"
                                                previewSrcList={JSON.parse(row.ahcoSixSign || [])}></el-image>
                                        }) : <span></span>
                                    }

                                </div>
                            </span>

                        );
                    },
                },
                {
                    field: "ahcoCheckDes",
                    key: "ahcoCheckDes",
                    title: "审核备注",
                    align: "center",
                    width: 180,
                },
               
                {
                    field: "ahcoStatus",
                    key: "ahcoStatus",
                    title: "状态",
                    width: 150,
                    fixed:'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ahcoStatus == 1 ? <el-tag size="mini">未处理</el-tag> : row.ahcoStatus == 2 ? <el-tag type="success" size="mini">按要求退房</el-tag>
                                        : row.ahcoStatus == 3 ? <el-tag type="danger" size="mini">未按要求退房</el-tag> : ''
                                }
                                {
                                    row.ahcoStatus == 1 ?
                                        <el-button
                                            size="mini" type="text" style="color:green" on-click={() => this.handleCheck(row)} > 审核 </el-button> : <span></span>
                                }

                            </span>
                        );
                    },
                },

                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" ,fixed:'right'},
                
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        handleCheck(row) {
            getAjHostelBaseList({ pageSize: 0 }).then((res) => {
                this.statusAll = res.data;
                this.formCheck.ahcoId = row.ahcoId;
                this.dialogStatus = true;
            });
        },
        handleAddReturn(row) {
            this.form2 = {
                ahcoId: row.ahcoId,
            }
            this.diaAddReturn = true;
        },
        SureBtn2() {
            this.$confirm("是否确定要新增, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    addAjAssetsFireEquipment(this.form2).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "新增成功!",
                            });
                            this.handleClose2()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleReturn(row) {
            this.$confirm("是否确定要归还吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjAssetsKeyBorrowReturnReturn({ aakbrId: row.aakbrId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "归还成功!",
                            });

                            this.partserch();
                            this.getDetailList();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        getDetail(row) {
            this.theRow = row;
            getAjAssetsKeyBorrowReturnList({ ahcoId: row.ahcoId }).then((res) => {
                this.tableDataDetail = res.data;
                this.diaDetail = true;
            });
        },
        getDetailList() {
            getAjAssetsKeyBorrowReturnList({ ahcoId: this.theRow.ahcoId }).then((res) => {
                this.tableDataDetail = res.data;
                this.diaDetail = true;
            });
        },
        downloadFile(url, name) {
            //下载
            if (!url) {
                return;
            }
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/aj-assets-key/exportAjAssetsKey',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('userid')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '退房申请.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsFireEquipment({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjAssetsFireEquipment(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjHostelCheckOutCheck(this.formCheck).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.closeStatus()
                }
            })
        },
        closeStatus() {
            this.formCheck = {};
            this.dialogStatus = false;
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjAssetsFireEquipment({ ahcoIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjAssetsFireEquipment({ ahcoId: row.ahcoId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjAssetsFireEquipment(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjAssetsFireEquipment(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 关闭弹框
        handleClose2() {
            this.diaAddReturn = false;
            this.$refs['formRef2'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.ahcoId = row.ahcoId
                    console.log(jsonObj);
                    updateAjAssetsFireEquipment(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjHostelCheckOutList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjHostelCheckOutList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjHostelCheckOutList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>